import React, { useEffect, useMemo, useReducer, useState } from 'react';
import { injectIntl,FormattedMessage } from 'react-intl';
import { i18nIntl, convertObjectToArray, MD5, getRemotedbUrl, isNotEmpty, isEmpty, truncate_string } from '../lib/ep';
import { useCSS } from '../lib/hooks';
import { BrowserRouter as Router, Route, Link, useHistory, useParams } from 'react-router-dom';
import { BackButton, MainButton, SquaredButton } from '../components/builder/ActionButton';
import ActionLink from '../components/builder/ActionLink';
import AppliedFilter from '../components/builder/AppliedFilter';
import ButtonCollection from '../components/builder/ButtonCollection';
import CopyLink from '../components/builder/CopyLink';
import { DisplayDynamicForm, DynamicForm } from '../components/builder/DynamicForm';
import EmailField from '../components/builder/EmailField';
import FloatingLayer from '../components/builder/FloatingLayer';
import Input from '../components/builder/Input';
import Message, { AlertMessage } from '../components/builder/Message';
import Model from '../components/builder/Model';
import PhoneField, { singlePhoneWithPrefix } from '../components/builder/PhoneField';
import SaveButton from '../components/builder/SaveButton';
import SearchField from '../components/builder/SearchField';
import SectionSubtitle from '../components/builder/SectionSubtitle';
import SectionTitle from '../components/builder/SectionTitle';
import Select from '../components/builder/Select';
import TextArea from '../components/builder/TextArea';
import Tooltip from '../components/builder/Tooltip';

import Paginator from '../components/utils/Paginator';
import HistoricLogsMap from '../components/utils/HistoricLogsMap';

import { operators, useFilterData, usePaginator } from '../components/FilterContent';
import FilterModal from '../components/backend/FilterModal';
import RibbonCollection from '../components/ui_items/RibbonCollection';
import IconedSelectorItems from '../components/wrappers/IconedSelectorItems';
import Module from '../components/ui_items/Module';
import OwnerPromoWrapper from '../components/ui_items/OwnerPromoWrapper';
import SectionHeader from '../components/ui_items/SectionHeader';
import OrganizerSelector from '../components/promotion/OrganizerSelector';
import { useAccount } from '../components/context/accountContext';
import Spinner from '../components/builder/Spinner';
import TabledItemsList, { Column } from '../components/builder/TabledItemsList';

const available_claim_status_props = {
	pending:{ id:0, title:"***Pending", color:'midgray' },
	claimed:{ id:1, title:"Claimed", color:'yellow' },
	progress:{ id:2, title:"In progress", color:'orange', is_light:false },
	delivered:{ id:3, title:"Delivered", color:'green', is_light:false },
	cancelled:{ id:4, title:"Cancelled", color:'red', is_light:false },
	expired:{ id:-1, title:"***Expired", color:'red', is_light:false },
};

const EmailHistory = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const { MyAccount } = useAccount();

	return (
		<TabledItemsList
			{...props}
			columns={[
				<Column
					main={true}
					title={i18n("Subject")}
					with_ellipsis={true}
					children={(item) => {
						return (
							<div class="gui_cutTextOnOverflow" style={{ height:'1.3em' }}>
								<strong>{item.subject}</strong>
							</div>
						)
					}}
				/>,
				<Column
					title={i18n("Date")}
					children={(item) => {
						return (
							<div>
								{EPGetTimezone(EPGetUnix(item.time), MyAccount.getAgentTimezone(), MyAccount.getAgentDateTimeFormat())}
							</div>
						)
					}}
				/>,
				<Column
					title={i18n("Status")}
					children={(item) => {
						return (
							<div>
								{i18n(item.state, 'ucfirst')}
							</div>
						)
					}}
				/>,
			]}
			empty_message={i18n("There are sent emails.")}
			max_height='50dvh'
			column_defs={{
				gridTemplateColumns:props?.column_defs ?? '1fr 150px 100px',
			}}
			_class={{ other:'not_in_top' }}
		/>
	)
};

export const SendClaimActions = ({user,promotion,prize, ...props}) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const promo_claim = props?.promo_claim ?? false;
	let pending = false;
	let claimed = false;
	let expired = false;
	if(![1,2,3,4].includes(parseInt(promo_claim.status)))pending = true;
	if([1].includes(parseInt(promo_claim.status)))claimed = true;
	if([-1].includes(parseInt(promo_claim.status)))expired = true;

	const has_prize_fulfillment = promotion?.prize_fulfillment ?? false;
	
	const enable_claim = (promotion.promotion_type_id == 42 || has_prize_fulfillment) ? true : false;
	const is_one_step_login = promotion?.one_step_login ?? false;
	const email = (isNotEmpty(user, 'email')) ? user.email : false;
	const display_send = (!expired && !claimed && pending && email && enable_claim) ? true : false;

	const display_stats = (email && enable_claim) ? true : false; 
	
	const [ display_stats_claim, setDisplayStatsClaim ] = useState(false);
	const [ prize_stats, setPrizeStats ] = useState(false);
	const [ display_send_claim, setDisplaySendClaim ] = useState(false);
	const [ sended, setSended ] = useState(false);

	const claim_link = `${window.public_url}my_prizes/${prize.promotion_id}/${prize.id}`;

	const claim_actions = [{
		name:"Link to claim your prize",
		skip:(has_prize_fulfillment && is_one_step_login) ? true : false,
		cta_whole:<CopyLink
			copy_link={claim_link}
			type='submit'
			icon='knk-links gui_small_icon'
		>Copy link</CopyLink>
	}, {
		name:props.intl.formatMessage({ id:"Send to {email}" }, { email }),
		cta_whole:<SaveButton
			onClick={(!sended) ? (e, cb) => sendClaimLinkToMail(cb) : null}
			icon={(!sended) ? 'knk-send' : 'knk-on greenIcon'}
		>Send</SaveButton>,
	}];

	const sendClaimLinkToMail = (cb) => {
		$.post(getRemotedbUrl(`/prizes/sendClaimMail/${prize.promotion_id}`), {
			email,
			prize_id:prize.id,
		}, (res) => {
			setSended(true);
			setTimeout(() => {
				setSended(false);
			}, 4000);

			if(cb != undefined) cb();
		});
	};

	const openStatsClaim = () => {
		setDisplayStatsClaim(true);
		$.post(getRemotedbUrl(`/prizes/claim_statistics/${prize.promotion_id}`), {
			email,
		}, (res) => {
			setPrizeStats(res);
		},'JSON');
	};

	return (
		<>	
			{(display_send) && (
				<SquaredButton
					icon='knk-send'
					tooltip={<Tooltip with_icon={false} position='left'>Send Claim your prize link</Tooltip>}
					onClick={() => setDisplaySendClaim(true)}
					aria-label="Send Claim your prize link"
				/>
			)}

			{(display_stats) && (
				<SquaredButton
					icon='knk-script'
					tooltip={<Tooltip with_icon={false} position='left' autotranslate={false}>{props.intl.formatMessage({ id:"Emails sent to {name}" }, { name:user.name })}</Tooltip>}
					onClick={() => openStatsClaim(true)}
					aria-label={props.intl.formatMessage({ id:"Emails sent to {name}" }, { name:user.name })}/>
			)}

			{(display_send_claim) && (
				<FloatingLayer _class={{size:'small'}} backButton={() => setDisplaySendClaim(false)}>
					<div class="without_actions">
						<SectionTitle>Send Claim your prize link</SectionTitle>
						<IconedSelectorItems
							items={claim_actions}
							is_margined={false}
						/>
					</div>
				</FloatingLayer>
			)}

			{(display_stats_claim) && (
				<FloatingLayer
					backButton={() => setDisplayStatsClaim(false)}
				>
					<div class="without_actions">
						<SectionTitle>{props.intl.formatMessage({ id:"Emails sent to {name}" }, { name:user.name })}</SectionTitle>

						<SectionSubtitle
							autotranslate={false}
						>{i18n("Email")}: <strong>{user?.email ?? i18n("error")}</strong></SectionSubtitle>

						{(!prize_stats) && (
							<Spinner
								_class={{ fullscreen:false }}
								force_bg={true}
							>Loading stats</Spinner>
						)}

						{((prize_stats?.status ?? false) == 1) && (
							<>
								<EmailHistory
									table_id='email_history'
									items={prize_stats?.sent ?? []}
									intl={props.intl}
								/>

								<p class="gui_not_in_top">
									<FormattedMessage
										id="The email statistics are only available during {days} days once sent."
										values={{ days:30 }}
									/>
								</p>
							</>
						)}

						{((prize_stats?.status ?? false) == 0) && (
							<AlertMessage
								_class={{ other:'in_bottom' }}
							>
								<p>
									<FormattedMessage
										id="The email statistics are only available during {days} days once sent."
										values={{ days:30 }}
									/>
								</p>
							</AlertMessage>
						)}
					</div>
				</FloatingLayer>
			)}
		</>
	)
};

export const StatusClaim = ({ user, prize, promotion, ...props}) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const [ display_historic, setDisplayHistoric ] = useState(false);
	const [ display_claim_data, setDisplayClaimData ] = useState(false);
	
	const agents = prize?.Agents ?? false;

	const getAgentName = (agent_id) => {
		if(agents === false) return null;
		if(agents[agent_id] == undefined) return null;
		return agents[agent_id];
	};

	const promo_claim = props?.promo_claim ?? false;
	const prize_type = props?.prize_type ?? (prize?.PrizeType ?? false);
	const status_items = [];

	const has_prize_fulfillment = promotion?.prize_fulfillment ?? false;
	const enable_claim = (promotion.promotion_type_id == 42 || has_prize_fulfillment) ? true : false;
	if(!enable_claim)return null;
	
	const detail_data = props?.detail_data ?? false;
	const detail_status = props?.detail_status ?? true;

	let claim_form = null;
	switch(parseInt(promo_claim.status)) {
		case 1:
			let status_claimed = available_claim_status_props.claimed;
			if(detail_data){
				claim_form = promotion?.claim_form ?? [];
				if(prize_type.claim_form != undefined) {
					claim_form = [...claim_form, ...JSON.parse(prize_type.claim_form)];
				}
				status_claimed = {
					...available_claim_status_props.claimed,
					onClick:() => setDisplayClaimData(true),
					icon:'knk-visible',
					icon_position:'end',
				};
			}
			status_items.push(status_claimed);
			break;

		case 2:
			status_items.push(available_claim_status_props.progress);
			break;

		case 3:
			status_items.push(available_claim_status_props.delivered);
			break;

		case 4:
			status_items.push(available_claim_status_props.cancelled);
			break;

		case -1:
			status_items.push(available_claim_status_props.expired);
			break;

		default:
			status_items.push(available_claim_status_props.pending);
		break;
	}
	

	let status_log = [
		{ key:'pending', date:prize.Prize.created, agent_name:getAgentName(promo_claim.created_agent_id) },
	];
	if(promo_claim.claim_date != undefined && promo_claim.claim_date != "") {
		status_log.push({ key:'claimed', date:promo_claim.claim_date});
	}
	if(promo_claim.progress_date != undefined && promo_claim.progress_date != "") {
		status_log.push({ key:'progress', date:promo_claim.progress_date, agent_name:getAgentName(promo_claim.progress_agent_id) });
	}
	if(promo_claim.delivered_date != undefined && promo_claim.delivered_date != "") {
		status_log.push({ key:'delivered', date:promo_claim.delivered_date, agent_name:getAgentName(promo_claim.delivered_agent_id) });
	}
	if(promo_claim.cancelled_date != undefined && promo_claim.cancelled_date != "") {
		status_log.push({ key:'cancelled', date:promo_claim.cancelled_date, agent_name:getAgentName(promo_claim.cancelled_agent_id) });
	}
	if(parseInt(promo_claim.status) == -1){
		status_log.push({ key:'expired', date:EPDateSubtractAndFormat(null, 'seconds', promo_claim.seconds_to_claim, 'YYYY-MM-DD HH:mm:ss') });
	}
	return (
		<>
			<ButtonCollection>
				{(detail_status) && (
					<SquaredButton
						icon='knk-magnify-in'
						//disabled={(pending) ? true : false}
						onClick={() => setDisplayHistoric(true)}
						aria-label="View"
					/>
				)}

				<RibbonCollection
					_class={{other:'in_top'}}
					items={status_items}
				/>

				
			</ButtonCollection>

			{(display_historic) && (
				<FloatingLayer _class={{size:'small'}} backButton={() => setDisplayHistoric(false)}>
					<div class="without_actions">
						<SectionTitle>Status change log</SectionTitle>

						<SectionSubtitle autotranslate={false}><strong>{user.name}</strong></SectionSubtitle>

						<SectionSubtitle autotranslate={false}>{i18n("Last update")}: <strong>{EPDateFormat(status_log[status_log.length - 1].date, 'ddd L, LT')}</strong></SectionSubtitle>

						<HistoricLogsMap
							current={status_log}
							all_steps={convertObjectToArray(available_claim_status_props)}
							start_steps={['pending']}
							end_steps={['delivered', 'cancelled', 'expired']}
							//date_format='ddd L, LT'
						/>
					</div>
				</FloatingLayer>
			)}

			{(display_claim_data) && (
				<FloatingLayer _class={{size:'small'}} backButton={() => setDisplayClaimData(false)}>
					<div class="without_actions">
						<SectionTitle>Claim information</SectionTitle>

						<dl class="answered_data">
							<div>
								<dt class="knk-user">{i18n("First name")}</dt>
								<dd>{user.first_name}</dd>
							</div>
							<div>
								<dt class="knk-user">{i18n("Last name")}</dt>
								<dd>{user.last_name}</dd>
							</div>
							<div>
								<dt class="knk-phone">{i18n("Telephone")}</dt>
								<dd>{singlePhoneWithPrefix(user.phone)}</dd>
							</div>
							<div>
								<dt class="knk-email">{i18n("Email")}</dt>
								<dd>{user.email}</dd>
							</div>
						</dl>
						
						<DisplayDynamicForm
							form={claim_form}
							values={promo_claim.claim_data}
							is_builder={true}
							not_margined={true}
						/>
					</div>
				</FloatingLayer>
			)}
		</>
	)
}

const SinglePrize = ({ prize, dispatch, ...props }) => {
	const user = prize?.User ?? {}; 
	const pclaim = prize?.PromoClaim ?? {};
	const email = (user.email != undefined && user.email != "" && user.email != " ") ? user.email : false;
	const phone = (user.phone != undefined && user.phone != "" && user.phone != " ") ? user.phone : false;

	let contact_information = [];
	if(phone !== false) {
		contact_information.push({
			title:singlePhoneWithPrefix(user.phone),
			color:'lightgray',
			_class:{ icon:'knk-phone' },
		});
	}
	if(email !== false) {
		contact_information.push({
			title:email,
			color:'lightgray',
			_class:{ icon:'knk-email' },
		});
	}

	const promo_link = (prize.Promotion.promotion_type_id == 42) ? `/onair/campaign/${prize.Promotion.id}`: `/promotions/profile/${prize.Promotion.id}`;
	const md5_attachment = MD5(`attachment_${prize.Prize.promotion_id}_${prize.Prize.id}`);
	const link_prize_attachment = prize.PrizeType.downloadable_file ? `${window.public_url}prizes/attachment/${prize.Prize.id}/${md5_attachment}` : false;

	return (
		<li class="single_item">
			<div class="tabled_item static_entry_info">
				{(props.index != undefined) && (
					<span class="entry_counter">
						<span class="counter">{parseInt(props.index) + 1}</span>
					</span>
				)}

				<span class="user_name">
					<h3 class="name">
						<ActionLink
							onClick={() => { dispatch({ type:'VIEW_DETAILS', prize })}}
							_class={{other:'gui_cutTextOnOverflow'}}
							autotranslate={false}
						>{isEmpty(user,'first_name',['']) ? user.name : `${user.first_name} ${user.last_name}`}</ActionLink>
					</h3>

					{(contact_information.length > 0) && (
						<RibbonCollection
							items={contact_information}
						/>
					)}
				</span>

				<span class="displaced">
					<ActionLink _href={promo_link} _target='_blank'>{prize.Promotion.title}</ActionLink>
				</span>

				<span class="displaced">
					{prize.PrizeType.title}
				</span>

				<span class="displaced">
					{moment.tz(prize.Prize.created,"Europe/Madrid").local().format('L, LT')}
				</span>

				<span class="displaced">
					<StatusClaim 
						user={user}
						prize={prize}
						promotion={prize.Promotion}
						promo_claim={pclaim}
						intl={props.intl}
					/>
				</span>

				<ButtonCollection _class={{other:'user_actions gui_not_margined_v'}}>
					{(link_prize_attachment) && (
						<CopyLink
							type="button"
							hide_label={true}
							icon="knk-attachment"
							copy_link={link_prize_attachment}
							copied_label="Copied!"
							secondary={false}>Copy URL of the attachment file</CopyLink>
					)}

					{(prize?.PromoClaim?.comment != undefined && pclaim.comment != "") && (
						<SquaredButton
							icon='knk-comment'
							tooltip={<Tooltip with_icon={false} position='left'>{pclaim.comment.replace(/\n/g, '<br />')}</Tooltip>}
							aria-label="Read comment"
						/>
					)}

					<SendClaimActions
						user={user}
						promo_claim={pclaim}
						promotion={prize.Promotion}
						prize={prize.Prize}
						intl={props.intl}
					/>

					<SquaredButton
						icon='knk-edit'
						onClick={() => { dispatch({ type:'VIEW_DETAILS', prize })}}
						aria-label="Edit"
					/>
				</ButtonCollection>
			</div>
		</li>
	)
};

const PrizeDetails = ({ prize,...props }) => {
	const available_status = [
		{ k:0, v:"***Pending" },
		{ k:1, v:"Claimed" },
		{ k:2, v:"In progress" },
		{ k:3, v:"Delivered" },
		{ k:4, v:"Cancelled" },
		{ k:-1, v:"***Expired" },
	];

	const promotion = props?.promotion?.Promotion ?? {};

	const [ state, dispatch ] = useReducer((state, action) => {
		switch(action.type) {
			case 'CHANGE':
				return {
					...state,
					promo_claim:{
						...state.promo_claim,
						[action.k]:action.v,
					},
				};

			case 'CHANGE_USER':
				switch (action.k) {
					case 'first_name':
						state.user.name = `${action.v} ${state.user.last_name}`;
						break;

					case 'last_name':
						state.user.name = ` ${state.user.first_name} ${action.v}`;
						break;
				}

				return {
					...state,
					user:{
						...state.user,
						[action.k]:action.v,
					},
				};

			default:
				return state;
		}
	}, {
		promo_claim:prize?.PromoClaim || {prize_type:prize.PrizeType.id,prize_id:prize.Prize.id},
		user:prize.User,
	});

	let joined_form = (promotion.claim_form != undefined) ? promotion.claim_form : [];
	if(prize.PrizeType.claim_form != undefined) {
		joined_form = [
			...joined_form,
			...JSON.parse(prize.PrizeType.claim_form),
		];
	}

	const save = (e, cb) => {
		$.post(`/prizes/updateClaim/${prize.User.promotion_id}/${prize.User.id}/${prize.Prize.id}`, {
			data:JSON.stringify(state.promo_claim),
			user:JSON.stringify(state.user),
		}, (response) => {
			state.promo_claim = response.PromoClaim;
			if(props.updateLocal != undefined) props.updateLocal(state);
			if(cb != undefined) cb();

			setTimeout(() => {
				props.close();
			}, 200);
		}, 'JSON');
	};

	const has_toc = ((promotion.toc != undefined && promotion.toc != "") || (promotion.external_toc_url != undefined && promotion.external_toc_url != ""));
	const has_policy = ((promotion.policy != undefined && promotion.policy != "") || (promotion.external_policy_url != undefined && promotion.external_policy_url != ""));
	
	let has_accepted_legals = prize?.PromoClaim?.meta?.created ?? false;
	if(!has_toc && !has_policy) has_accepted_legals = false;

	return (
		<FloatingLayer _class={{size:'small'}} backButton={() => props.close()}>
			<div>
				<SectionTitle autotranslate={false}>
					<FormattedMessage id="Claim information for {user}" values={{user:prize?.User?.name ?? 'Unknown'}} />
				</SectionTitle>

				<div class="gui_separated_children">
					<Model model={state.user} change={(k, v) => dispatch({ type:'CHANGE_USER', k, v })}>
						<Input
							name="first_name"
							_class={{first:true, size:70}}
						>First name</Input>

						<Input
							name="last_name"
							_class={{size:70}}
						>Last name</Input>

						<PhoneField
							name="phone"
							avail_countries={props?.avail_countries}
							_class={{size:70}}
						>Telephone</PhoneField>

						<EmailField
							name="email"
							_class={{size:70}}
						>Email</EmailField>
					</Model>

					<DynamicForm
						form={joined_form}
						user={state.promo_claim.claim_data}
						onChange={(v) => { dispatch({ type:'CHANGE', k:'claim_data', v }) }}
						is_builder={true}
						field_config={{
							signature:{
								auto_url:`/users/upload/${promotion.id}`,
								auto_type:"custom_fields",
								is_builder:true,
							},
							attach:{
								auto_url:`/users/upload/${promotion.id}`,
								auto_type:"custom_fields",
								is_builder:true,
							}
						}}
						extra_field_props={{
							_class:{ size:70 },
						}}
					/>

					<Model model={state.promo_claim} change={(k, v) => dispatch({ type:'CHANGE', k, v })}>
						<Select name="status" values={available_status} _class={{size:70}}>Status</Select>

						<TextArea name="comment">Internal comment</TextArea>
					</Model>
				</div>

				{(has_accepted_legals !== false) && (
					<Message
						icon='knk-toc'
						_class={{ other:'in_bottom' }}
					>
						<p>
							{(prize.PromoClaim.meta.toc_url != undefined && prize.PromoClaim.meta.policy_url == undefined) && (
								<FormattedMessage id="This user accepted the {link} on {date}." values={{link:<ActionLink _href={prize.PromoClaim.meta.toc_url} _target='_blank'>Terms and conditions</ActionLink>, date:<strong>{EPDateFormat(prize.PromoClaim.meta.created, 'dddd LL, LT')}</strong>}} />
							)}

							{(prize.PromoClaim.meta.toc_url == undefined && prize.PromoClaim.meta.policy_url != undefined) && (
								<FormattedMessage id="This user accepted the {link} on {date}." values={{link:<ActionLink _href={prize.PromoClaim.meta.policy_url} _target='_blank'>Privacy policy</ActionLink>, date:<strong>{EPDateFormat(prize.PromoClaim.meta.created, 'dddd LL, LT')}</strong>}} />
							)}

							{(prize.PromoClaim.meta.toc_url != undefined && prize.PromoClaim.meta.policy_url != undefined) && (
								<FormattedMessage id="This user accepted the {link1} and {link2} on {date}." values={{link1:<ActionLink _href={prize.PromoClaim.meta.toc_url} _target='_blank'>Terms and conditions</ActionLink>, link2:<ActionLink _href={prize.PromoClaim.meta.policy_url} _target='_blank'>Privacy policy</ActionLink>, date:<strong>{EPDateFormat(prize.PromoClaim.meta.created, 'dddd LL, LT')}</strong>}} />
							)}
						</p>
					</Message>
				)}

				<ButtonCollection in_floating={true}>
					<SaveButton
						onClick={save}
					>Save changes</SaveButton>
				</ButtonCollection>
			</div>
		</FloatingLayer>
	);
};

const reducer = (state, action) => {
	switch(action.type) {
		case 'SEARCH':
			return {
				...state,
				search:action.search,
			};

		case 'SEARCH_PRIZE':
			return {
				...state,
				search_prize:action.search,
			};

		case 'SET_PRIZES':
			return {
				...state,
				range:action.range,
				prizes:action.prizes,
				promotions:action.promotions
			}
			
		case 'FILTER_STATUS':
			return {
				...state,
				status:action.filter,
			};

		case 'FILTER_PROMOTION':
			return {
				...state,
				promotion_id:action.filter,
			};

		case 'VIEW_DETAILS':
			return {
				...state,
				view_details:action.prize,
			};

		case 'TOGGLE_FILTER':
			return {
				...state,
				filter_modal:!state.filter_modal,
			};

		case 'BULK_MODAL':
			return {
				...state,
				bulk_modal:action.state,
			};
		case 'SET_DATA': 
			return {
				...state,
				promotions:action.data.promotions,
				prizes:{data:action.data.prizes}
			}

		default:
			return state;
	}
};

const PrizeFulfillment = injectIntl((props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const history = useHistory();
	const { organizing, promotion_id } = useParams();

	const label = props.labels.find((l) => (l.Label.id == organizing));

	const [ orderingType, setOrderingType ] = useState('Prize.created');
	const [ ordering_direction, setOrderingDirection ] = useState('DESC');

	useCSS('comp/live_panel.css');
	const [ state, dispatch ] = useReducer(reducer, {
		search:'',
		status:'',
		view_details:false,
		filter_modal:false,
		bulk_modal:false,
		promotions:(isNotEmpty(props.data,organizing)) ? (props.data[organizing]?.promotions ?? []) : [],
		prizes:(isNotEmpty(props.data,organizing)) ? { data:(props.data[organizing]?.prizes ?? []) } : [],
	});

	useEffect(() => {
		if(isEmpty(props.data,organizing)) return;
		const d = {prizes:props.data[organizing]?.prizes ?? [], promotions:props.data[organizing]?.promotions ?? []}
		dispatch({ type:'SET_DATA', data:d });
	}, [ props.data ]);

	const prizeTypes = useMemo(() => {
		const types = [];
		if(!state.promotions) return;

		state.promotions.map((promotion) => {
			promotion.PrizeTypes.map((pt) => {
				types.push(pt);
			});
		});

		return types.map((pt) => ({ k:pt.id,v:pt.title }));
	}, [ state.promotions ]);

	const prize_extra_fields = useMemo(() => {
		if(!state.promotions) return;

		const fields = [];
		state.promotions.map((promotion) => {
			if(!promotion.Promotion.claim_form) return;

			const f = promotion.Promotion.claim_form;
			fields.push(...f);

			promotion.PrizeTypes.map((p) => {
				if(p.claim_form) {
					let f = JSON.parse(p.claim_form);
					fields.push(...f);
				}
			});
		});

		return fields;
	}, [ state.promotions ])

	const fetchPrizes = (k, v) => {
		$.get(getRemotedbUrl(`/users/fulfillment_prizes/${organizing}/${v}`), (res) => {
			filterData({ type:'SETDATA', data:{ data:(res?.prizes ?? []) }});
			dispatch({ type:'SET_PRIZES', range:v, ...res });
		}, 'JSON');
	};

	const searchName = (key, value) => {
		const filter = {
			key:'search_name',
			name:"Name",
			tier1:['User.name','User.phone','User.email'],
			tier2:{ ...operators.textOperators },
			tier3:'input',
			type:'string',
		};

		filterData({
			type:'SETFILTER',
			filter:{
				key:'search_name',
				value,
				operator:'like_all',
				filter,
			},
			unique:true,
		});

		dispatch({ type:'SEARCH', search:value });
	};

	const [ data, filterData ] = useFilterData(state?.prizes ?? []);

	const interceptFilterData = (action) => {
		if(action.type == 'RESET_FILTERS') history.push(`/${organizing}`);
		if(action.type == 'REMOVEFILTER' && action.filter.key == 'filter_promotion') history.push(`/${organizing}`);
		filterData(action);
	};

	useEffect(() => {
		if(!promotion_id) {
			const current_filter = data.filters.find((f) => f.key == 'filter_promotion');
			if(data.filters.find((f) => f.key == 'filter_promotion')) {
				filterData({ type:'REMOVEFILTER', filter:current_filter });
			}
			return;
		}
		filterByPromotion(null,promotion_id);
	}, [ promotion_id ]);

	const filterStatus = (key, value) => {
		const filter = {
			key:'filter_status',
			name:"Status",
			type:'numeric',
			tier1:['PromoClaim.status'],
			tier2:{ ...operators.numericOperators },
			tier3:'input',
			humanize:(current) => {
				const _status = convertObjectToArray(available_claim_status_props).find((st) => (st.id == current.value));

				return (
					<FormattedMessage
						id="The status is {status}"
						values={{status:`"${i18n(_status.title)}"`}}
					/>
				);
			},
		};

		filterData({
			type:'SETFILTER',
			filter:{
				key:'filter_status',
				value,
				operator:'=',
				filter,
			},
			unique:true,
		});

		dispatch({ type:'FILTER_STATUS', filter:value });
	};

	const searchPrize = (key, value) => {
		const filter = {
			key:'filter_prize',
			name:"Prize",
			tier1:['PrizeType.title'],
			tier2:{ ...operators.textOperators },
			tier3:'input',
			type:'string',
		};

		filterData({
			type:'SETFILTER',
			filter:{
				key:'filter_prize',
				value,
				operator:'like_all',
				filter,
			},
			unique:true,
		});

		dispatch({ type:'SEARCH_PRIZE', search:value });
	};

	const navigateFilter = (key, value) => {
		if(value == '') {
			history.push(`/${organizing}`);
			return;
		}
		history.push(`/${organizing}/${value}`);
	};

	const filterByPromotion = (key, value) => {
		const filter = {
			key:'filter_promotion',
			name:"Promotion",
			type:'numeric',
			tier1:['Prize.promotion_id'],
			tier2:{ ...operators.numericOperators },
			tier3:'input',
			humanize:(current) => {
				const p = state.promotions.find((pr) => (
					pr.Promotion.id == current.value
				));
				let _title = '';
				if(!p)return null
				if(isNotEmpty(p.Promotion,'internal_ref',['']))_title = p.Promotion?.internal_ref;
				if(isNotEmpty(p.Promotion,'title',['']))_title = p.Promotion?.title;
				if(_title == '') _title = `#${p.Promotion.id}`;
				return <FormattedMessage id="Promotion {title}" values={{title:`: "${truncate_string(_title,20)}"`}} />;
			},
		};
		
	
		const p = state.promotions.find((pr) => (
			pr.Promotion.id == value
		));
		
		if(p){
			filterData({
				type:'SETFILTER',
				filter:{
					key:'filter_promotion',
					value,
					operator:'=',
					filter,
				},
				unique:true,
			});
			dispatch({ type:'FILTER_PROMOTION', filter:value });
		}
	}

	const updateLocal = ({ promo_claim, user }) => {
		filterData({
			type:'APPLY_ACTION',
			match:(u) => (u.Prize.id == promo_claim.prize_id) ? true : false,
			action:(u) => {
				return {
					...u,
					PromoClaim:{ ...promo_claim },
					User:{ ...user },
					claim_status:promo_claim.status,
				}
			}
		});
	}

	const changeSorting = (field) => {
		let newordering;
		if(field != orderingType) {
			setOrderingType(field);
			newordering = 'DESC';
		} else {
			newordering = (ordering_direction == 'ASC') ? 'DESC' : 'ASC';
		}

		setOrderingDirection(newordering);

		let type = "text";

		filterData({
			type:'SETSORT',
			sort:{ field:field, direction:newordering, type },
		});
	};

	const [ paged_data, pagination, goToPage ] = usePaginator(data.filtered, 15);

	const sortingIconClass = (field) => {
		return `knk-order-${((field != orderingType) ? 'none grayIcon' : ordering_direction.toLowerCase())}`;
	};

	const tierGetOptions = (current, level) => {
		if(level == 0) {
			let ops = current.filter.tier2;

			return {
				key:'operator',
				options:Object.keys(ops).map((k) => ({ k, v:ops[k] })),
			};
		}
	
		if(level == 1) {
			if(current.filter.tier3 == undefined) return null;

			return {
				type:current.filter.tier3,
				options:[{
					k:current.filter.tier3,
					v:"Input",
				}],
			};
		}
	}

	const filters = useMemo(() => {
		if (!state.promotions) return;
		const filters = [{
			key:'name',
			name:"Name",
			group:['user'],
			tier1:'User.name',
			tier2:{ ...operators.textOperators },
			tier3:'input',
			getOptions:tierGetOptions,
		}, {
			key:'inner_comment',
			name:"Comment",
			group:['user'],
			tier1:'PromoClaim.comment',
			tier2:{ ...operators.textOperators },
			tier3:'input',
			getOptions:tierGetOptions,
		}];

		state.promotions.map((promotion) => {
			if(!promotion.Promotion.claim_form) return;
			if(promotion.Promotion.claim_form == '[]') return;

			const f = promotion.Promotion.claim_form;

			let condition = {
				key:`claim_${promotion.Promotion.id}`,
				name:promotion.Promotion.title,
				group:['claim'],
				tier1:(a, b) => {
					if(b == undefined) return null;
					if(a.PromoClaim?.claim_data == undefined) return null;
					return a.PromoClaim.claim_data[b.options[0].k];
				},
				tier2:('test' == 'dropdown') ? ['a', 'b'] : { ...operators.textOperators },
				getOptions:(current, level) => {
					if(level == 0) {
						const fields = [...f];
						promotion.PrizeTypes.map((p) => {
							if(p.claim_form) {
								let f = JSON.parse(p.claim_form);
								fields.push(...f);
							}
						});
						
						return {
							key:'field_id',
							options:fields.map((field) => ({
								k:field.short_title ?? field.id,
								v:field.title,
							})),
						};
					}
				
					if(level == 1) {
						const field = prize_extra_fields.find((ef) => (
							ef.id == current.options[0].k || ef.short_title == current.options[0].k
						));

						if (field.type == 'dropdown') {
							return {
								key:'value',
								type:'multiple',
								options:field.values.split("\n").map((v) => ({ k:v, v })),
							};
						}

						if(field.type != 'dropdown') {
							condition.tier3 = 'input';

							return {
								key:'value',
								type:'input',
							};
						}

						return {
							type:current.filter.tier3,
							options:[{
								k:current.filter.tier3,
								v:"Input",
							}],
						};
					}
				},
			}
			filters.push(condition);
		})

		return filters;

	}, [ state.promotions ]);

	//if(!state.promotions) return null;

	const promotions = [{ k:'', v:`-- ${i18n("Campaign")} --`}].concat((state?.promotions ?? []).map((p) => (
		{ k:p.Promotion.id, v:p.Promotion.title }
	)));

	const promotion_filter = data.filters.find((f) => (f.key == 'filter_promotion'))?.value;
	
	const status_values = [
		{ k:'', v:`-- ${i18n("All statuses")} --` },
		{ k:'0', v:"Pending" },
		{ k:'1', v:"Claimed" },
		{ k:'2', v:"In progress" },
		{ k:'3', v:"Delivered" },
		{ k:'4', v:"Cancelled" },
		{ k:'-1', v:"***Expired" },
	];

	const ranges = [
		{ k:'3', v:"Last 3 months" },
		{ k:'6', v:"Last 6 months" },
		{ k:'12', v:"Last year" },
		{ k:'0', v:"All time" },
	];

	return (
		<OwnerPromoWrapper
			menu={false}
			add_module={false}
			sticky_header='-35px'
			custom_header={<SectionHeader
				title={i18n("Claimed prizes manager")}
				subtitle={
					<>
						{i18n("Tool to manage claimed prizes, pending ones, and track delivery.")}<br/>
						<Link to={`/${label?.Label?.id ?? '#'}`}><span>{i18n("Organizing brand")}: <strong>{label?.Label?.name ?? "None"}</strong></span></Link>
					</>
				}
				icon={{ icon:'knk-given-prize' }}
				filters={<ButtonCollection>
					<SearchField
						_class={{first:true}}
						name="search"
						value={state.search}
						change={searchName}
						placeholder="Search by user"
					/>
					
					<SearchField
						_class={{first:true}}
						name="search_prize"
						value={state.search_prize}
						change={searchPrize}
						placeholder="Search by prize"
					/>

					<Select
						_class={{first:true}}
						name="status"
						value={promotion_filter}
						change={navigateFilter}
						values={promotions}
					/>

					<Select
						_class={{first:true}}
						name="promotion_id"
						value={state.status}
						change={filterStatus}
						values={status_values}
					/>

					<Select
						_class={{first:true}}
						name="range"
						value={state.range}
						change={fetchPrizes}
						values={ranges}
					/>

					<ActionLink
						onClick={() => dispatch({ type:'TOGGLE_FILTER' })}
						_class={{other:'gui_not_in_start_small gui_not_in_end gui_not_in_end_small'}}
					>Advanced filter</ActionLink>
				</ButtonCollection>}
			>
				<ButtonCollection>
					<BackButton
						onClick={() => { history.push(`/`); }}
					/>
				</ButtonCollection>
			</SectionHeader>}
		>
			<AppliedFilter filters={data.filters} dispatch_function={interceptFilterData} />

			<Module>
				<ul class="simple_registered_entries_list">
					<li class="list_header single_item">
						<div class="tabled_item">
							<span class="user_name">{i18n("Total")}: {data.filtered.length}</span>

							<span class="is_sortable">
								<ActionLink _class={{icon:sortingIconClass('Promotion.title'), other:'gui_cutTextOnOverflow'}} onClick={() => changeSorting('Promotion.title')}>Contest</ActionLink>
							</span>

							<span class="is_sortable">
								<ActionLink _class={{icon:sortingIconClass('PrizeType.title'), other:'gui_cutTextOnOverflow'}} onClick={() => changeSorting('PrizeType.title')}>Prize</ActionLink>
							</span>

							<span class="is_sortable">
								<ActionLink _class={{icon:sortingIconClass('Prize.created'), other:'gui_cutTextOnOverflow'}} onClick={() => changeSorting('Prize.created')}>Date</ActionLink>
							</span>

							<span class="is_sortable">
								<ActionLink _class={{icon:sortingIconClass('Prize.status'), other:'gui_cutTextOnOverflow'}} onClick={() => changeSorting('Prize.status')}>Status</ActionLink>
							</span>
							
							<span class="user_actions">{i18n("Actions")}</span>
						</div>
					</li>

					{data.filtered && paged_data.map((prize, p) => {
						return (
							<SinglePrize
								key={prize.Prize.id}
								promotion={prize.Promotion}
								index={p}
								prize={prize}
								dispatch={dispatch}
								intl={props.intl}
							/>
						)
					})}

					{(data.length == 0 || data.filtered.length == 0) && (
						<li>{i18n("There are no winners to display.")}</li>
					)}
				</ul>

				{(pagination.total_pages > 1) && (
					<Paginator
						{...pagination}
						goToPage={goToPage}
					/>
				)}
				
				{(state.filter_modal) && (
					<FilterModal toggle={() => dispatch({type:'TOGGLE_FILTER'})} sections={[{label:i18n("Common"),key:'user'},{label:i18n("Claim"),key:'claim'}]} filters={filters} stateFilters={data.filters} dispatch={filterData} >
						<AppliedFilter filters={data.filters} dispatch_function={filterData} in_layer={true} />
					</FilterModal>
				)}

				{(state.view_details != false) && (
					<PrizeDetails
						prize={state.view_details}
						promotion={(state?.promotions ?? []).find((p) => p.Promotion.id == state.view_details.Prize.promotion_id)}
						updateLocal={updateLocal}
						close={() => dispatch({ type:'VIEW_DETAILS', prize:false })}
					/>
				)}
			</Module>
		</OwnerPromoWrapper>
		
	);
});

const SelectorWrapper = (props) => {
	const history = useHistory();
	return (
		<OrganizerSelector
			onSelectItem={(label)=>{
				//props.fetchData(label.id);
				history.push(`/${label.id}`);
			}}
			use_router={true}
			labels={props.labels}
			section_title="Claimed prizes manager"
			title_icon='knk-present-fill'
		/>
	)
}

const FullfillmentWrapper = (props) => {
	const {organizing} = useParams();
	
	useEffect(()=>{
		props.fetchData(organizing);
	},[])
	
	return (
		<PrizeFulfillment 
			data={props.data}
			labels={props.labels}
		/>
	)
}

const routereducer = (state,action) => {
	switch (action.type) {
		case 'SET_DATA':
			return {
				...state,
				data: {
					...state.data,
					[action.label_id]:action.prizes
				}
			}
			break;
	
		default:
			return state;
	}
}

const Routing = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const { MyAccount } = useAccount();

	const [state,dispatch] = useReducer(routereducer,{
		data:props.data
	})

	const fetchData = async (label_id) => {
		if (!isEmpty(state.data,label_id)) return;
		const prizes = await fetch(`/users/fulfillment_prizes/${label_id}`).then(response=>response.json());
		dispatch({type:'SET_DATA',label_id,prizes});
	}

	if(!MyAccount.hasMinPlan(5)){
		return (
			<div class="gui_grid">
				<SectionHeader
					title={i18n("Claimed prizes manager")}
					subtitle={i18n("Tool to manage claimed prizes, pending ones, and track delivery.")}
					icon={{ icon:'knk-given-prize' }}
				/>
				<Module>
					<p>{i18n("This feature is available for customers with an active White Label, or Corporate subscription plan.")}</p>
					<ButtonCollection>
						<MainButton
							_href={`${window.panel_url}plans/add`}
						>Purchase a subscription plan</MainButton>
					</ButtonCollection>
					<ActionLink _href={`${window.zendesk_base_url}31956244405652`} _target='_blank'>Learn more about the claimed prizes manager</ActionLink>
				</Module>
			</div>
		)
	}

	return (
		<Router basename="/users/prize_fulfillment">
			<Route exact={true} path="/">
				<SelectorWrapper {...props} fetchData={fetchData} />
			</Route>
		
			<Route exact={true} path="/:organizing/:promotion_id?">
				<FullfillmentWrapper 
					fetchData={fetchData}
					data={state.data}
					labels={props.labels}
				/>
			</Route>
		</Router>
	)
}


export default injectIntl(Routing);